import { StanButton, StanDropdown } from '@/components';

interface Currency {
    name: string;
    value: string;
}

interface CurrencySectionProps {
    currency: string;
    savedCurrency: string;
    currencies: Currency[];
    currenciesLoading: boolean;
    saveLoading: boolean;
    saveState: 'idle' | 'saving' | 'saved';
    onCurrencyChange: (value: string) => void;
    onSave: () => void;
}

export const CurrencySection = ({
    currency,
    savedCurrency,
    currencies,
    currenciesLoading,
    saveLoading,
    saveState,
    onCurrencyChange,
    onSave,
}: CurrencySectionProps) => {
    const isDirty = currency !== savedCurrency;
    const currentCurrencyLabel = currencies.find(c => c.value === currency)?.name || currency;

    return (
        <div className='mt-6'>
            <div className='mb-2'>
                <h4>Currency</h4>
            </div>
            <div className='flex flex-wrap items-center gap-2'>
                <div className='w-full max-w-xl'>
                    <StanDropdown
                        id='currency-select'
                        name='currency'
                        options={currencies.map(curr => ({
                            label: curr.name,
                            value: curr.value,
                        }))}
                        onSelect={value => onCurrencyChange(value.value)}
                        currentValue={{
                            label: currentCurrencyLabel,
                            value: currency,
                        }}
                        placeholder={currenciesLoading ? 'Loading currencies...' : 'Select currency'}
                        disabled={currenciesLoading}
                    />
                </div>

                {isDirty && (
                    <StanButton
                        name='currency-save-button'
                        onClick={onSave}
                        loading={saveLoading}
                        disabled={saveLoading}
                    >
                        Save Currency
                    </StanButton>
                )}

                {saveState === 'saving' && (
                    <div className='text-caption-1-regular text-gray flex items-center'>
                        <div className='mr-2 size-4 animate-spin rounded-full border-b-2' />
                        Saving...
                    </div>
                )}

                {saveState === 'saved' && <div className='text-caption-1-regular text-gray'>Saved!</div>}
            </div>
        </div>
    );
};
